module.exports = __webpack_public_path__ + "static/media/img15.e28413fc.jpg";